var _style, _filter, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWidgetMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 538 784",
    style: {
      enableBackground: "new 0 0 538 784"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{filter:url(#Rectangle_263);}\n\t.st1{fill:#002E81;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{opacity:5.000000e-02;fill:#002E81;enable-background:new    ;}\n\t.st4{opacity:0.1;fill:#002E81;enable-background:new    ;}\n\t.st5{fill:none;stroke:#002E81;stroke-width:0.3;}\n\t.st6{opacity:0.2;fill:#FFFFFF;enable-background:new    ;}\n\t.st7{opacity:0.1;fill:#FFFFFF;enable-background:new    ;}\n\t.st8{opacity:0.75;fill:#FFFFFF;enable-background:new    ;}\n\t.st9{opacity:0.5;fill:#FFFFFF;enable-background:new    ;}\n")), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    filterUnits: "userSpaceOnUse",
    height: 784,
    id: "Rectangle_263",
    width: 538,
    x: 0,
    y: 0
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic",
    operator: "over"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1284",
    transform: "translate(-227 -3493.42)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 227, 3493.42)",
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_263-2_1_",
    className: "st1",
    d: "M65,45h408c11,0,20,9,20,20v654c0,11-9,20-20,20H65c-11,0-20-9-20-20V65 C45,54,54,45,65,45z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_264",
    className: "st2",
    d: "M291,3642.4h410c11,0,20,9,20,20v552c0,11-9,20-20,20H291c-11,0-20-9-20-20v-552 C271,3651.4,280,3642.4,291,3642.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_265",
    x: 271,
    y: 4087,
    className: "st3",
    width: 450,
    height: 62
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_266",
    className: "st4",
    d: "M300,4167h28c5.5,0,10,4.5,10,10v28c0,5.5-4.5,10-10,10h-28c-5.5,0-10-4.5-10-10v-28 C290,4171.5,294.5,4167,300,4167z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_270",
    className: "st4",
    d: "M307,4102L307,4102c9.4,0,17,7.6,17,17l0,0c0,9.4-7.6,17-17,17l0,0c-9.4,0-17-7.6-17-17 l0,0C290,4109.6,297.6,4102,307,4102z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_267",
    className: "st4",
    d: "M363,4167h29c5.5,0,10,4.5,10,10v28c0,5.5-4.5,10-10,10h-29c-5.5,0-10-4.5-10-10v-28 C353,4171.5,357.5,4167,363,4167z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_268",
    className: "st4",
    d: "M427,4167h28c5.5,0,10,4.5,10,10v28c0,5.5-4.5,10-10,10h-28c-5.5,0-10-4.5-10-10v-28 C417,4171.5,421.5,4167,427,4167z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_269",
    className: "st4",
    d: "M490,4167h28c5.5,0,10,4.5,10,10v28c0,5.5-4.5,10-10,10h-28c-5.5,0-10-4.5-10-10v-28 C480,4171.5,484.5,4167,490,4167z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_269_1_",
    className: "st4",
    d: "M551.5,4167h28c5.5,0,10,4.5,10,10v28c0,5.5-4.5,10-10,10h-28c-5.5,0-10-4.5-10-10v-28 C541.5,4171.5,546,4167,551.5,4167z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_70",
    className: "st5",
    x1: 271.5,
    y1: 3950.5,
    x2: 404.5,
    y2: 3950.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_71",
    className: "st5",
    x1: 581.5,
    y1: 3950.5,
    x2: 721.5,
    y2: 3950.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_326",
    className: "st6",
    d: "M300.6,3561.3h187.2c2.8,0,5,2.2,5,5v19.2c0,2.8-2.2,5-5,5H300.6c-2.8,0-5-2.2-5-5v-19.2 C295.6,3563.5,297.8,3561.3,300.6,3561.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_327",
    className: "st7",
    d: "M300.6,3600.3h330.2c2.8,0,5,2.2,5,5v11.2c0,2.8-2.2,5-5,5H300.6c-2.8,0-5-2.2-5-5v-11.2 C295.6,3602.5,297.8,3600.3,300.6,3600.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_328",
    className: "st4",
    d: "M299.6,3975.3h326.3c5.5,0,10,4.5,10,10v81.3c0,5.5-4.5,10-10,10H289.6l0,0v-91.3 C289.6,3979.8,294.1,3975.3,299.6,3975.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_329",
    className: "st8",
    d: "M315.8,3999.2h290.1c3.3,0,6.1,2.7,6.1,6.1l0,0c0,3.3-2.7,6.1-6.1,6.1H315.8 c-3.3,0-6.1-2.7-6.1-6.1l0,0C309.7,4001.9,312.4,3999.2,315.8,3999.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_332",
    className: "st4",
    d: "M418.7,3942.2h146.2c2.8,0,5,2.2,5,5v8.1c0,2.8-2.2,5-5,5H418.7c-2.8,0-5-2.2-5-5v-8.1 C413.7,3944.4,416,3942.2,418.7,3942.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_330",
    className: "st8",
    d: "M315.8,4019.8h290.1c3.3,0,6.1,2.7,6.1,6.1l0,0c0,3.3-2.7,6.1-6.1,6.1H315.8 c-3.3,0-6.1-2.7-6.1-6.1l0,0C309.7,4022.5,312.4,4019.8,315.8,4019.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_331",
    className: "st8",
    d: "M315.8,4040.8h290.1c3.3,0,6.1,2.7,6.1,6.1l0,0c0,3.3-2.7,6.1-6.1,6.1H315.8 c-3.3,0-6.1-2.7-6.1-6.1l0,0C309.7,4043.5,312.4,4040.8,315.8,4040.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_3",
    className: "st3",
    d: "M697.1,4115.3c1.5,0.7,2.1,2.5,1.3,4c-0.3,0.6-0.8,1.1-1.3,1.3l-25.3,12.6 c-1.5,0.7-3.3,0.1-4-1.3c-0.2-0.4-0.3-0.9-0.3-1.3v-25.3c0-1.7,1.3-3,3-3c0.5,0,0.9,0.1,1.3,0.3L697.1,4115.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "close",
    className: "st9",
    d: "M700.6,3570.6l-5.8-5.9l5.9-5.8c0.2-0.2,0.2-0.6,0-0.9l-1.7-1.7c-0.1-0.1-0.3-0.2-0.4-0.2 c-0.2,0-0.3,0.1-0.4,0.2l-5.8,5.8l-5.8-5.8c-0.1-0.1-0.3-0.2-0.4-0.2c-0.2,0-0.3,0.1-0.4,0.2l-1.7,1.7c-0.2,0.2-0.2,0.6,0,0.9 l5.9,5.8l-5.8,5.9c-0.1,0.1-0.2,0.3-0.2,0.4c0,0.2,0.1,0.3,0.2,0.4l1.7,1.7c0.1,0.1,0.3,0.2,0.4,0.2c0.2,0,0.3-0.1,0.4-0.2l5.8-5.8 l5.8,5.8c0.1,0.1,0.3,0.2,0.4,0.2c0.2,0,0.3-0.1,0.4-0.2l1.7-1.7c0.1-0.1,0.2-0.3,0.2-0.4C700.7,3570.9,700.7,3570.7,700.6,3570.6 L700.6,3570.6z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWidgetMobile);
export default __webpack_public_path__ + "static/media/widget-mobile.886703113e455f3c03fc8af58e597069.svg";
export { ForwardRef as ReactComponent };